export function toolbarGoBack(): ng.IDirective {
    return {
        restrict: "E",
        template: require('./toolbarGoBack.html')
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/navigation/toolbar/toolbarGoBack.directive.ts
 **/